import angular from 'angular'
import template from './template.html'

angular.module('nominas.pendientes')
  .component('nominasPendientesLayoutsLayoutNomina', {
    template: template,
    controller: NominasPendientesLayoutsLayoutNominaComponent,
    bindings: {
      idNomina: '<',
      fechaPago: '<',
      total: '<',
      habilitado: '<',
      colaboradores: '<',
      onChange: '&',
    },
  });

function NominasPendientesLayoutsLayoutNominaComponent($filter) {
  let $ctrl = this,
    orderBy = $filter('orderBy');

  $ctrl.$onChanges = $onChanges;
  $ctrl.expandido = false;
  $ctrl.seleccionar = seleccionar;
  $ctrl.seleccionarTodo = seleccionarTodo;
  $ctrl.todoSeleccionado = undefined;

  function $onChanges(changes) {
    if (changes.colaboradores) {
      $ctrl.colaboradores = orderBy($ctrl.colaboradores, 'colaborador');

      totalizar();
    }
  }

  function seleccionar(item) {
    if (!$ctrl.habilitado)
      return;

    item.$$selected = !item.layout_generado && !item.$$selected;

    totalizar();
    $ctrl.onChange();
  }

  function seleccionarTodo(selected) {
    if (!$ctrl.habilitado)
      return;

    $ctrl.colaboradores
      .forEach(function (item) {
        item.$$selected = !item.layout_generado && !!selected;
      });

    totalizar();
    $ctrl.onChange();
  }

  function totalizar() {
    $ctrl.todoSeleccionado = $ctrl.colaboradores
      .every(function (item) {
        return item.$$selected;
      });
  }
}



// WEBPACK FOOTER //
// ./src/nominas/pendientes/components/layouts/layout/nomina/component.js